// src/components/superadmin/CampusDashboard/StaffList.jsx
import React from "react";
import { MdPerson, MdEdit, MdDelete, MdPrint, MdVisibility } from "react-icons/md";

const StaffList = ({ staff, campus, onEdit, onDelete, onView }) => {
  // Simple print function that uses window.print() instead
  const handlePrintStaff = (staffMember) => {
    // Create a printable version
    const printWindow = window.open('', '_blank', 'width=800,height=600');
    if (!printWindow) {
      alert('Please allow popups to print staff reports.');
      return;
    }
    
    const doc = printWindow.document;
    doc.write(`
      <html>
        <head>
          <title>Staff Report - ${staffMember.name}</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 40px; }
            h1 { color: #0f1b2d; border-bottom: 2px solid #0f1b2d; padding-bottom: 10px; }
            .header { display: flex; justify-content: space-between; margin-bottom: 30px; }
            .info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
            .info-item { padding: 8px; border-bottom: 1px solid #e2e8f0; }
            .label { font-weight: bold; color: #64748b; }
            .value { color: #1a202c; }
            .documents-section { margin-top: 30px; }
            table { width: 100%; border-collapse: collapse; }
            th { background: #f8fafc; text-align: left; padding: 10px; border-bottom: 2px solid #e2e8f0; }
            td { padding: 10px; border-bottom: 1px solid #e2e8f0; }
            @media print { body { padding: 20px; } }
          </style>
        </head>
        <body>
          <div class="header">
            <h1>Staff Profile</h1>
            <div>
              <strong>Campus:</strong> ${campus?.name || '—'}<br>
              <strong>Staff ID:</strong> ${staffMember.staff_id || staffMember.id || '—'}
            </div>
          </div>
          
          <div class="info-grid">
            <div class="info-item"><span class="label">Name:</span> <span class="value">${staffMember.name}</span></div>
            <div class="info-item"><span class="label">Email:</span> <span class="value">${staffMember.email || '—'}</span></div>
            <div class="info-item"><span class="label">Phone:</span> <span class="value">${staffMember.phone || '—'}</span></div>
            <div class="info-item"><span class="label">CNIC:</span> <span class="value">${staffMember.cnic || '—'}</span></div>
            <div class="info-item"><span class="label">Designation:</span> <span class="value">${staffMember.designation || '—'}</span></div>
            <div class="info-item"><span class="label">Department:</span> <span class="value">${staffMember.department || '—'}</span></div>
            <div class="info-item"><span class="label">Gender:</span> <span class="value">${staffMember.gender || '—'}</span></div>
            <div class="info-item"><span class="label">Joining Date:</span> <span class="value">${staffMember.joining_date || '—'}</span></div>
            <div class="info-item"><span class="label">Salary:</span> <span class="value">${staffMember.salary ? `PKR ${Number(staffMember.salary).toLocaleString()}` : '—'}</span></div>
            <div class="info-item"><span class="label">Address:</span> <span class="value">${staffMember.address || '—'}</span></div>
            <div class="info-item"><span class="label">Emergency Contact:</span> <span class="value">${staffMember.emergency_contact_name || '—'}</span></div>
            <div class="info-item"><span class="label">Emergency Number:</span> <span class="value">${staffMember.emergency_contact_number || '—'}</span></div>
          </div>
          
          ${staffMember.documents && staffMember.documents.length > 0 ? `
            <div class="documents-section">
              <h2>Documents</h2>
              <table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Type</th>
                    <th>File Name</th>
                    <th>Uploaded</th>
                  </tr>
                </thead>
                <tbody>
                  ${staffMember.documents.map((doc, i) => `
                    <tr>
                      <td>${i + 1}</td>
                      <td>${doc.name || '—'}</td>
                      <td>${doc.type || '—'}</td>
                      <td>${doc.file_name || '—'}</td>
                      <td>${doc.uploaded_at ? new Date(doc.uploaded_at).toLocaleDateString() : '—'}</td>
                    </tr>
                  `).join('')}
                </tbody>
              </table>
            </div>
          ` : ''}
          
          <p style="margin-top: 40px; color: #94a3b8; font-size: 12px; text-align: center;">
            Generated on ${new Date().toLocaleString()}
          </p>
          <script>
            window.onload = function() {
              window.print();
            }
          <\/script>
        </body>
      </html>
    `);
    doc.close();
  };

  if (!staff || staff.length === 0) {
    return (
      <div style={{ padding: "60px 20px", textAlign: "center", color: "#64748b" }}>
        <div style={{ fontSize: "48px", marginBottom: "12px" }}>👥</div>
        <h3 style={{ color: "#1a202c", marginBottom: "6px" }}>No Staff Members</h3>
        <p style={{ fontSize: "13px" }}>Click "Add Staff" to add the first staff member to this campus.</p>
      </div>
    );
  }

  return (
    <div style={{ overflowX: "auto" }}>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ padding: "10px 16px", fontSize: "11px", fontWeight: 700, color: "#64748b", background: "#f8fafc", borderBottom: "2px solid #e2e8f0", textTransform: "uppercase", letterSpacing: "0.4px", textAlign: "left" }}>#</th>
            <th style={{ padding: "10px 16px", fontSize: "11px", fontWeight: 700, color: "#64748b", background: "#f8fafc", borderBottom: "2px solid #e2e8f0", textTransform: "uppercase", letterSpacing: "0.4px", textAlign: "left" }}>Name</th>
            <th style={{ padding: "10px 16px", fontSize: "11px", fontWeight: 700, color: "#64748b", background: "#f8fafc", borderBottom: "2px solid #e2e8f0", textTransform: "uppercase", letterSpacing: "0.4px", textAlign: "left" }}>Designation</th>
            <th style={{ padding: "10px 16px", fontSize: "11px", fontWeight: 700, color: "#64748b", background: "#f8fafc", borderBottom: "2px solid #e2e8f0", textTransform: "uppercase", letterSpacing: "0.4px", textAlign: "left" }}>Department</th>
            <th style={{ padding: "10px 16px", fontSize: "11px", fontWeight: 700, color: "#64748b", background: "#f8fafc", borderBottom: "2px solid #e2e8f0", textTransform: "uppercase", letterSpacing: "0.4px", textAlign: "left" }}>Email</th>
            <th style={{ padding: "10px 16px", fontSize: "11px", fontWeight: 700, color: "#64748b", background: "#f8fafc", borderBottom: "2px solid #e2e8f0", textTransform: "uppercase", letterSpacing: "0.4px", textAlign: "center" }}>Docs</th>
            <th style={{ padding: "10px 16px", fontSize: "11px", fontWeight: 700, color: "#64748b", background: "#f8fafc", borderBottom: "2px solid #e2e8f0", textTransform: "uppercase", letterSpacing: "0.4px", textAlign: "center" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {staff.map((member, idx) => (
            <tr
              key={member.id || idx}
              style={{ background: idx % 2 === 0 ? "#ffffff" : "#fafbfd", cursor: "pointer" }}
              onMouseEnter={(e) => e.currentTarget.style.background = "#e8f0fe"}
              onMouseLeave={(e) => e.currentTarget.style.background = idx % 2 === 0 ? "#ffffff" : "#fafbfd"}
              onClick={() => onView?.(member)}
            >
              <td style={{ padding: "12px 16px", fontSize: "13px", color: "#1a202c", borderBottom: "1px solid #e2e8f0", verticalAlign: "middle" }}>
                <span style={{ color: "#94a3b8", fontWeight: 600, fontSize: "12px" }}>{idx + 1}</span>
              </td>
              <td style={{ padding: "12px 16px", fontSize: "13px", color: "#1a202c", borderBottom: "1px solid #e2e8f0", verticalAlign: "middle" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <div style={{ width: 32, height: 32, borderRadius: "50%", background: "#0f1b2d", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, fontSize: "13px", flexShrink: 0 }}>
                    {(member.name || "?").charAt(0).toUpperCase()}
                  </div>
                  <span style={{ fontWeight: 600 }}>{member.name}</span>
                </div>
              </td>
              <td style={{ padding: "12px 16px", fontSize: "13px", color: "#1a202c", borderBottom: "1px solid #e2e8f0", verticalAlign: "middle" }}>
                <span style={{ display: "inline-block", padding: "2px 10px", borderRadius: "20px", fontSize: "11px", fontWeight: 700, background: "#e8f0fe", color: "#1d4ed8" }}>
                  {member.designation || "—"}
                </span>
              </td>
              <td style={{ padding: "12px 16px", fontSize: "13px", color: "#1a202c", borderBottom: "1px solid #e2e8f0", verticalAlign: "middle" }}>
                {member.department || "—"}
              </td>
              <td style={{ padding: "12px 16px", fontSize: "13px", color: "#1a202c", borderBottom: "1px solid #e2e8f0", verticalAlign: "middle" }}>
                {member.email}
              </td>
              <td style={{ padding: "12px 16px", fontSize: "13px", color: "#1a202c", borderBottom: "1px solid #e2e8f0", verticalAlign: "middle", textAlign: "center" }}>
                <span style={{ 
                  display: "inline-block", 
                  padding: "2px 10px", 
                  borderRadius: "20px", 
                  fontSize: "11px", 
                  fontWeight: 700,
                  background: member.documents?.length > 0 ? "#f0fff4" : "#f1f5f9", 
                  color: member.documents?.length > 0 ? "#16a34a" : "#94a3b8" 
                }}>
                  {member.documents?.length || 0}
                </span>
              </td>
              <td style={{ padding: "12px 16px", fontSize: "13px", color: "#1a202c", borderBottom: "1px solid #e2e8f0", verticalAlign: "middle", textAlign: "center" }}>
                <div style={{ display: "flex", gap: "6px", justifyContent: "center" }}>
                  <button
                    onClick={(e) => { e.stopPropagation(); onView?.(member); }}
                    title="View Staff"
                    style={{ width: 32, height: 32, borderRadius: "7px", border: "none", background: "#0f1b2d", color: "#fff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px" }}
                  >
                    <MdVisibility />
                  </button>
                  <button
                    onClick={(e) => { e.stopPropagation(); handlePrintStaff(member); }}
                    title="Print Staff Report"
                    style={{ width: 32, height: 32, borderRadius: "7px", border: "none", background: "#1d4ed8", color: "#fff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px" }}
                  >
                    <MdPrint />
                  </button>
                  <button
                    onClick={(e) => { e.stopPropagation(); onEdit(member); }}
                    title="Edit Staff"
                    style={{ width: 32, height: 32, borderRadius: "7px", border: "none", background: "#d97706", color: "#fff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px" }}
                  >
                    <MdEdit />
                  </button>
                  <button
                    onClick={(e) => { e.stopPropagation(); onDelete(member.id); }}
                    title="Delete Staff"
                    style={{ width: 32, height: 32, borderRadius: "7px", border: "none", background: "#dc2626", color: "#fff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px" }}
                  >
                    <MdDelete />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default StaffList;